import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import "highlight.js/styles/github-dark.css";

const MarkdownRenderer = ({ content }) => {
  if (!content) return null;

  // Fix unclosed code blocks
  const backtickCount = (content.match(/```/g) || []).length;
  const fixedContent = backtickCount % 2 !== 0 ? content + "\n```" : content;

  return (
    <div className="em-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeHighlight]}
      >
        {fixedContent}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer